import { MdFolder, MdFolderOpen, MdKeyboardArrowRight } from "react-icons/md";
import { getItemIcon } from "./mock";
import { countItems } from "./helpers";

// Splits `text` into segments, wrapping case-insensitive matches with <strong>
function highlightText(text, query) {
   if (!query) return text;
   const parts = [];
   const q = query.toLowerCase();
   let remaining = text;
   let key = 0;
   while (remaining.length > 0) {
      const idx = remaining.toLowerCase().indexOf(q);
      if (idx === -1) {
         parts.push(<span key={key++}>{remaining}</span>);
         break;
      }
      if (idx > 0) parts.push(<span key={key++}>{remaining.slice(0, idx)}</span>);
      parts.push(
         <strong key={key++} className="font-extrabold! ">
            {remaining.slice(idx, idx + query.length)}
         </strong>
      );
      remaining = remaining.slice(idx + query.length);
   }
   return parts;
}

// ─── TreeRow ──────────────────────────────────────────────────────────────────
export function TreeRow({
   node,
   depth,
   isSelected,
   isExpanded,
   onToggleExpand,
   onSelect,
   onDoubleClick,
   onDragStart,
   listId,
   searchQuery,
}) {
   const isGroup = node.type === "group";

   return (
      <div
         draggable
         onDragStart={(e) => onDragStart(e, node, listId)}
         onClick={(e) => onSelect(e, node, listId)}
         onDoubleClick={(e) => { e.stopPropagation(); onDoubleClick(node, listId); }}
         className={`flex items-center gap-1.5 ${depth === 0 ? "pl-1! pr-3!" : "pr-3!"} py-2! mb-0.5! rounded-md! border! cursor-pointer select-none transition-colors duration-100 group box-border! ${isSelected
            ? "bg-(--listHeaderBackgroundColor) text-(--primaryColor) border-(--primaryColor)"
            : "hover:bg-(--listHeaderBackgroundColor) text-(--textColor) border-transparent!"
            }`}
         style={{ paddingLeft: `${12 + depth * 9}px` }}
         title={node.description || node.label}
      >
         {/* Expand chevron (groups only) */}
         {isGroup ? (
            <span
               className="flex-shrink-0 text-(--textColor) hover:text-(--textColor) transition-transform duration-150"
               style={{ transform: isExpanded ? "rotate(90deg)" : "rotate(0deg)" }}
               onClick={(e) => {
                  e.stopPropagation();
                  onToggleExpand(node.id);
               }}
            >
               <MdKeyboardArrowRight size={16} />
            </span>
         ) : (
            <span className="w-4 flex-shrink-0" />
         )}

         {/* Node icon */}
         <span
            className={`flex-shrink-0 ${isGroup ? "text-yellow-400" : "text-(--primaryColor)"
               }`}
         >
            {isGroup ? (
               isExpanded ? (
                  <MdFolderOpen size={16} />
               ) : (
                  <MdFolder size={16} />
               )
            ) : (
               typeof node.icon === 'string' ? getItemIcon(node.icon) : node.icon
            )}
         </span>

         {/* Label */}
         <span className="text-sm truncate flex-1 text-left">
            {highlightText(node.label, searchQuery)}
         </span>

         {/* Group child count badge */}
         {isGroup && (
            <span className="text-xs! bg-(--listHeaderBackgroundColor) rounded-full px-1.5! ml-auto! shrink-0">
               <span className="text-(--textColor) opacity-60">
                  {countItems(node.children || [])}
               </span>
            </span>
         )}
      </div>
   );
}
